
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class LogosSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            freeScroll: true,
            cellSelector: '.logos-carousel__slide',
            cellAlign: 'left'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.logos-carousel__slide');
        this.slidesCount = this.$slides.length;

		this._checkSlider();

		let resizeTimer;

		$(window).on("resize", () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this._checkSlider();
			}, 200);
		});
    }

    _checkSlider() {
		const width = document.body.clientWidth;

		let shouldInit = false;

		if (width < 470 && this.slidesCount > 1) {
			shouldInit = true;
		} else if (width >= 470 && width < 720 && this.slidesCount > 2) {
			shouldInit = true;
		} else if (width >= 720 && width < 972 && this.slidesCount > 3) {
			shouldInit = true;
		} else if (width >= 972 && width < 1208 && this.slidesCount > 4) {
			shouldInit = true;
		} else if (width >= 1208 && width < 1456 && this.slidesCount > 5) {
			shouldInit = true;
		} else if (width >= 1456 && this.slidesCount > 6) {
			shouldInit = true;
		}

		if (shouldInit && !this.slider) {
			this._createSlider();
			// console.log("Logos carousel - slider init");
		}

		if (!shouldInit && this.slider) {
			this.slider.destroy();
			this.slider = null;
			// console.log("Logos carousel - slider destroyed");
		}
	}

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }
}

export default LogosSlider;
